import { getEnvironment } from '../../../lib/utils.mjs';

// User ids come back as numbers from some fields and strings from others
// (me.id vs game.hostIds vs feeds.metadata.hostIds), so compare as strings.
export const isGameHost = (userId, hostIds) =>
  userId != null &&
  (hostIds || []).some((hostId) => String(hostId) === String(userId));

// WayBetter staff who aren't admins, by user id: the comma-separated
// WB_HUB_HOST_FEED_STAFF_USER_IDS, read on production only, where it is
// set (the list itself lives in the env, not here).
export const isHostFeedStaff = (userId, environment = getEnvironment()) => {
  const { WB_ENV, WB_HUB_HOST_FEED_STAFF_USER_IDS } = environment || {};
  if (userId == null || WB_ENV !== 'production') return false;

  return (WB_HUB_HOST_FEED_STAFF_USER_IDS || '')
    .split(',')
    .some((staffId) => staffId.trim() === String(userId));
};

// The host feed is for the game's hosts and for WayBetter staff: admins,
// role admin or super_admin in wb-user-service, and on production the
// staff in WB_HUB_HOST_FEED_STAFF_USER_IDS. Not an @waybetter.app email:
// sign-up doesn't verify it.
export const canOpenHostFeed = (me, hostIds, environment) =>
  me?.isAdmin === true ||
  isGameHost(me?.id, hostIds) ||
  isHostFeedStaff(me?.id, environment);

export const isSameUser = (userId, otherUserId) =>
  userId != null && String(userId) === String(otherUserId);
